import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, setBlockTracking as _setBlockTracking, Fragment as _Fragment, createVNode as _createVNode, renderList as _renderList } from "vue"

const _hoisted_1 = ["data-productid", "data-page"]
const _hoisted_2 = ["href", "aria-label"]
const _hoisted_3 = {
  key: 6,
  class: "discount-badge"
}
const _hoisted_4 = ["href", "aria-label"]
const _hoisted_5 = {
  key: 0,
  class: "spec row product-time-row"
}
const _hoisted_6 = { class: "content-text time" }
const _hoisted_7 = ["totalsecondsleft", "status"]
const _hoisted_8 = {
  key: 0,
  class: "spec col"
}
const _hoisted_9 = ["href"]

import ImageOverlay from "../../../../../commons/product/overlays/image-overlay.vue";
import fallbackImage from "../../../../frontend-productpage/fallback-image.jpg?file";
import labels from "../../../../shared/labels";
import specs from "../common/product-specs.vue";
import productImage from "../common/product-image.vue";
import {
    type TrackingInformation,
    storeLinkTrackingInformation,
} from "../../../../../../utilities/product-link-tracking";
import Filler from "../../../../shared/Filler.vue";
import { type PropType, computed, onMounted, ref } from "vue";
import { type IProductPictureInfo } from "../../list-item";
import {
    format,
    isNullOrEmpty,
    isNullOrWhitespace,
} from "../../../../../../shared/utils/string";
import { isValidSecondsleft } from "../../../../../commons/product/auction/countdown";
import axios from "axios";
import {
    type AddToCartResponse,
    afterAddToCart,
} from "../../../../frontend-productpage/shop/cart-adding";
import FadeAndSlide from "../../../../shared/FadeAndSlide.vue";
import ActionButton from "./action-button.vue";
import { type OverwriteSettings } from "../../../../../commons/product/overwrite-settings";
import {
    ensureInitializedRegistration,
    type ProductRegistrationResult,
} from "../common/product-updater";


export default /*@__PURE__*/_defineComponent({
  __name: 'product',
  props: {
    productId: Number,
    productName: String,
    page: Number,
    imageInfo: Object as PropType<IProductPictureInfo>,
    overlayText: String,
    overlayTextType: String,
    //overlayTextLink: String,
    indexOfList: Number,
    thirdPartyStamp: Boolean,
    relatedAuctionStamp: Boolean,
    relatedShopStamp: Boolean,
    isAuction: Boolean,
    isBuynow: Boolean,
    isShop: Boolean,
    productValue: Number,
    price: Number,
    mobile: Boolean,
    secondsLeft: Number,
    timeIsNotStarted: Boolean,
    overwriteSettings: Object as PropType<OverwriteSettings>,
    link: String,
    hasBid: Boolean,
    priceComparisonEnabled: Boolean,
    trackingInfo: Object as PropType<TrackingInformation>,
    scaleOfScreen: {
        type: Number,
        default: 1,
    },
    registration: Object as PropType<ProductRegistrationResult>,
},
  emits: [
    "input",
    "update:productId",
    "update:productName",
    "update:link",
    "update:overlayText",
    "update:overlayTextType",
    //"update:overlayTextLink",
    "update:thirdPartyStamp",
    "update:relatedAuctionStamp",
    "update:relatedShopStamp",
    "update:secondsLeft",
    "update:timeIsNotStarted",
    "update:isAuction",
    "update:isShop",
    "update:isBuynow",
    "update:productValue",
    "update:hasBid",
    "update:price",
],
  setup(__props, { emit: __emit }) {

const timeText = ref("");

const props = __props;

function mapLabels(value: string[]) {
    return value.map((x: string, i: number, a: string[]) => ({
        i: i,
        txt: x,
        a: a,
    }));
}

const actionButtonText = computed(() => {
    if (addToCartAction.value) {
        return labels.frontendProductpage.specs.addToCart;
    }
    if (
        props.isShop &&
        !isNullOrEmpty(
            labels.frontendProductList.productSpecs.actionTexts.makeOffer_shop
        )
    )
        return labels.frontendProductList.productSpecs.actionTexts
            .makeOffer_shop;
    else if (
        props.isBuynow &&
        !isNullOrEmpty(
            labels.frontendProductList.productSpecs.actionTexts.makeOffer_buyNow
        )
    )
        return labels.frontendProductList.productSpecs.actionTexts
            .makeOffer_buyNow;
    else return labels.frontendProductList.productSpecs.actionTexts.makerOffer;
});

const emit = __emit;

const cartLink = ref<string>();

const actionButtonLoading = ref(false);

async function clickEvent(ev: Event) {
    if (props.productId == null) {
        ev.preventDefault();
        return;
    }
    if (addToCartAction.value) {
        ev.preventDefault();
        actionButtonLoading.value = true;
        try {
            const response = await axios.post<AddToCartResponse>(
                "/auctionProduct/addToCart",
                undefined,
                {
                    params: {
                        productId: props.productId,
                        orderQuantity: 1,
                    },
                }
            );
            if (response.data.success !== true) {
                throw new Error(response.data.errors.join("\n"));
            }

            afterAddToCart(
                props.productId,
                response.data.cartItemsCount,
                response.data.firstAdd
            );

            cartLink.value = response.data.cartLink;

            return;
        } finally {
            actionButtonLoading.value = false;
        }
    }
}

const addToCartAction = computed(() => {
    if (props.isShop !== true) {
        return false;
    }
    return true;
});

const el = ref<HTMLLIElement>();

onMounted(() => {
    if (el.value == null) throw new Error("missing ref");

    ensureInitializedRegistration(props, emit, timeText);

    if (props.trackingInfo != null)
        storeLinkTrackingInformation(el.value, props.trackingInfo);
});

const timeLabel = computed(() => {
    if (props.isShop) {
        if (props.timeIsNotStarted)
            return labels.frontendProductList.productSpecs.headers
                .timeLeftToStart_shop;
        else
            return labels.frontendProductList.productSpecs.headers
                .timeLeft_shop;
    }
    if (props.timeIsNotStarted)
        return labels.frontendProductList.productSpecs.headers.timeLeftToStart;
    else return labels.frontendProductList.productSpecs.headers.timeLeft;
});

const imgInfo = computed(() => {
    if (props.imageInfo == null) return props.imageInfo;
    if (props.imageInfo.pictureUrl != null) return props.imageInfo;
    const res: IProductPictureInfo = {
        pictureUrl: fallbackImage,
        pictureWidth: 470,
        pictureHeight: 353,
        pictureSrcSet: undefined,
        pictureSrcSetAsWebp: undefined,
        pictureUrlAsWebp: undefined,
    };
    return res;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    ref_key: "el",
    ref: el,
    "data-productid": __props.productId,
    class: _normalizeClass([
            '',
            _ctx.$style['product-list-item'],
            __props.productId == null ? _ctx.$style['product-list-item--filler'] : '',
            __props.isAuction ? _ctx.$style['product-type-auction'] : '',
        ]),
    "data-item-type": "product",
    "data-page": __props.page
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['product-details', _ctx.$style['product-details']])
    }, [
      _createElementVNode("a", {
        href: __props.link ?? '#',
        "aria-label": __props.productName,
        class: _normalizeClass(['product-image', _ctx.$style['product-image']]),
        "data-product-link": ""
      }, [
        _createElementVNode("div", null, [
          (imgInfo.value == null)
            ? (_openBlock(), _createBlock(Filler, {
                key: 0,
                box: "",
                "aspect-ratio": "4/3"
              }))
            : (_openBlock(), _createBlock(productImage, {
                key: 1,
                "scale-of-screen": __props.scaleOfScreen,
                item: imgInfo.value,
                "fill-width": "",
                "provided-image-width": __props.mobile ? 228 : undefined,
                lazy: __props.indexOfList == null || __props.indexOfList > 4
              }, null, 8 /* PROPS */, ["scale-of-screen", "item", "provided-image-width", "lazy"])),
          (__props.overlayText != null)
            ? (_openBlock(), _createBlock(ImageOverlay, {
                key: 2,
                type: __props.overlayTextType
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.overlayText), 1 /* TEXT */)
                ], undefined, true),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["type"]))
            : _createCommentVNode("v-if", true),
          (__props.thirdPartyStamp)
            ? (_openBlock(), _createBlock(ImageOverlay, {
                type: "third-party-stamp",
                key: "third-party-stamp"
              }))
            : _createCommentVNode("v-if", true),
          (__props.relatedAuctionStamp)
            ? (_openBlock(), _createBlock(ImageOverlay, {
                type: "related-auction",
                key: "related-auction"
              }))
            : _createCommentVNode("v-if", true),
          (__props.relatedShopStamp)
            ? (_openBlock(), _createBlock(ImageOverlay, {
                type: "related-shop",
                key: "related-shop"
              }))
            : _createCommentVNode("v-if", true),
          (
                            __props.isShop &&
                            __props.productValue != null &&
                            __props.price != null &&
                            __props.productValue > __props.price &&
                            Math.round((1 - __props.price / __props.productValue) * 100) >= 10
                        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(format)(
                                _unref(labels).frontendProductList.discount,
                                Math.round((1 - __props.price / __props.productValue) * 100) +
                                    "%"
                            )), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ], 10 /* CLASS, PROPS */, _hoisted_2),
      _createElementVNode("div", {
        class: _normalizeClass(['', _ctx.$style['under-content']])
      }, [
        _cache[0] || (
          _setBlockTracking(-1, true),
          (_cache[0] = _createElementVNode("div", {
            class: _normalizeClass(['', _ctx.$style['title-row']])
          }, [
            _createElementVNode("a", {
              href: __props.link ?? '#',
              "aria-label": __props.productName,
              class: _normalizeClass(['product-title', _ctx.$style['product-title']]),
              "data-product-link": ""
            }, [
              _createElementVNode("span", null, [
                (__props.productName == null)
                  ? (_openBlock(), _createBlock(Filler, {
                      key: 0,
                      max: 70
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(__props.productName), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
              ])
            ], 10 /* CLASS, PROPS */, _hoisted_4)
          ], 2 /* CLASS */)).cacheIndex = 0,
          _setBlockTracking(1),
          _cache[0]
        ),
        _createElementVNode("div", {
          class: _normalizeClass(['product-info', _ctx.$style['product-info']])
        }, [
          (__props.productId != null)
            ? (_openBlock(), _createBlock(specs, {
                key: 0,
                "product-id": __props.productId,
                "is-auction": __props.isAuction,
                "is-buynow": __props.isBuynow,
                "is-shop": __props.isShop,
                "product-value": __props.productValue,
                price: __props.price,
                "price-comparison-enabled": __props.priceComparisonEnabled,
                "product-estimated-value": __props.productValue,
                "overwrite-settings": __props.overwriteSettings,
                "has-bid": __props.hasBid,
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('input', $event))),
                mobile: __props.mobile
              }, {
                default: _withCtx(() => [
                  (
                                __props.secondsLeft != null &&
                                _unref(isValidSecondsleft)(__props.secondsLeft)
                            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", {
                          class: _normalizeClass({
                                        'header-text': true,
                                        time: __props.mobile,
                                    })
                        }, _toDisplayString(timeLabel.value), 3 /* TEXT, CLASS */),
                        (__props.mobile)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" ")
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", {
                            class: "countdown-text",
                            totalsecondsleft: __props.secondsLeft,
                            status: 
                                            __props.timeIsNotStarted
                                                ? 'notStart'
                                                : 'started'
                                        
                          }, _toDisplayString(timeText.value), 9 /* TEXT, PROPS */, _hoisted_7)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", {
                    class: _normalizeClass({
                                'spec no-border-after buttons': true,
                                flex: !__props.mobile,
                            })
                  }, [
                    (!__props.mobile)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(ActionButton, {
                            "action-button-text": actionButtonText.value,
                            "product-id": __props.productId,
                            link: __props.link,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (clickEvent($event))),
                            busy: actionButtonLoading.value
                          }, null, 8 /* PROPS */, ["action-button-text", "product-id", "link", "busy"])
                        ]))
                      : (_openBlock(), _createBlock(ActionButton, {
                          key: 1,
                          "action-button-text": actionButtonText.value,
                          "product-id": __props.productId,
                          link: __props.link,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (clickEvent($event))),
                          busy: actionButtonLoading.value
                        }, null, 8 /* PROPS */, ["action-button-text", "product-id", "link", "busy"])),
                    _createCommentVNode("@{\r\n                    var popupArguments = auctionId.HasValue ? (object)new { productId = Model.ProductId, auctionId } : new { productId = Model.ProductId };\r\n                    }\r\n                    @if (!WebsiteProvider.GetSiteParameterBool(\"Auction_DisableListBidAndBuy\") && Model.TypeHasAuction && Model.TimeIsActive)\r\n                    {\r\n                        <div class=\"spec col\">\r\n                            <button id=\"BidPopUpBtn\" type=\"button\" data-productid=\"@Model.ProductId\" class=\"action-button\" onclick=\"productListPopup.call(this)\" data-action=\"open-popup-bid\" data-action-url=\"@Url.Action(\" GenerateBidPopup\", \"AuctionProduct\" , popupArguments)\">\r\n                                @Model.SiteVariables.Text(\"M_Auction_BidButtonText\")\r\n                            </button>\r\n                        </div>\r\n                    }\r\n                    @if (!WebsiteProvider.GetSiteParameterBool(\"Auction_DisableListBidAndBuy\") && showBuyNowButton)\r\n                    {\r\n                        <div class=\"spec col\">\r\n                            <button id=\"BuyNowPopUpBtn\" type=\"button\" data-productid=\"@Model.ProductId\" class=\"action-button\" onclick=\"productListPopup.call(this)\" data-action=\"open-popup-buynow\" data-action-url=\"@Url.Action(\" GenerateBuyNowPopup\", \"AuctionProduct\" , popupArguments)\">\r\n                                @Model.SiteVariables.Text(Model.TypeHasLoserOffer ? \"M_Auction_LoserOffer_ButtonText\" : \"M_Checkout_BuyNow\")\r\n                            </button>\r\n                        </div>\r\n                    }")
                  ], 2 /* CLASS */),
                  _createVNode(FadeAndSlide, null, {
                    default: _withCtx(() => [
                      (
                                    !_unref(isNullOrWhitespace)(cartLink.value) &&
                                    cartLink.value != null
                                )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([
                                    _ctx.$style['success-text'],
                                    'success-text',
                                ])
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapLabels(
                                        _unref(labels).frontendProductpage.specs.addedToCart.split(
                                            '{0}'
                                        )
                                    ), (textPart) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                _createTextVNode(_toDisplayString(textPart.txt), 1 /* TEXT */),
                                (
                                            textPart.i != textPart.a.length - 1
                                        )
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: cartLink.value,
                                      class: _normalizeClass(_ctx.$style['cart-link'])
                                    }, _toDisplayString(_unref(labels).frontendProductpage.specs
                                                .addedToCartName), 11 /* TEXT, CLASS, PROPS */, _hoisted_9))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }),
                  _createCommentVNode("<template v-if=\"item.productTypeInt === 8\">\r\n                            <template v-if=\"item.productIsActive && item.timeIsActive && item.specialConfigurations.disableStockLimitations !== true\">\r\n                                <div :class=\"['spec', !mobile ? 'col' : 'row', 'shop-product-stock-status']\">\r\n                                    <div class=\"shop-product-stock-status-row\">\r\n                                        <span>\r\n                                            <i :class=\"'icon-stock-status icon-stock-status--'+item.stockStatusIconCssClass\"></i>\r\n                                            {{item.stockStatusText}}\r\n                                        </span>\r\n                                    </div>\r\n                                </div>\r\n                            </template>\r\n                        </template>")
                ], undefined, true),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["product-id", "is-auction", "is-buynow", "is-shop", "product-value", "price", "price-comparison-enabled", "product-estimated-value", "overwrite-settings", "has-bid", "mobile"]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})